import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { NavPills } from "@totalsoft/rocket-ui";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BallotIcon from "@mui/icons-material/Ballot";
import ScoringCategoryListContainer from "./ScoringCategoryListContainer";
import ScoringIndicatorListContainer from "./ScoringIndicatorListContainer";
import ScoringAttributeListComponent from "./ScoringAttributeListComponent";

class ScoringClassificationComponent extends React.PureComponent {
  render() {
    const { documentScoringGridId, scoringClassification, indicatorPeriodList, disabled, dimensionPeriods, t } =
      this.props;
    let tabsArray = [];

    if (scoringClassification.categories.length > 0) {
      tabsArray.push({
        label: t("Scoring.ScoringClassification.Categories"),
        icon: <DashboardIcon />,
        content: (
          <ScoringCategoryListContainer
            documentScoringGridId={documentScoringGridId}
            scoringClassificationId={scoringClassification.scoringClassificationId}
            categoryList={scoringClassification.categories}
            disabled={disabled}
          />
        )
      });
    }

    if (scoringClassification.financialIndicators.length > 0) {
      tabsArray.push({
        label: t("Scoring.ScoringClassification.Indicators"),
        icon: <ScheduleIcon />,
        content: (
          <ScoringIndicatorListContainer
            indicatorList={scoringClassification.financialIndicators || []}
            periodList={indicatorPeriodList}
            documentScoringGridId={documentScoringGridId}
            scoringClassificationId={scoringClassification.scoringClassificationId}
            disabled={disabled}
            dimensionPeriods={dimensionPeriods}
          />
        )
      });
    }

    if (scoringClassification.attributes.length > 0) {
      tabsArray.push({
        label: t("Scoring.ScoringClassification.Attributes"),
        icon: <BallotIcon />,
        content: <ScoringAttributeListComponent attributeList={scoringClassification.attributes} />
      });
    }

    return (
      <NavPills
        color="info"
        orientation="vertical"
        tabs={tabsArray}
        sx={{ "& ~ [role=tab-panel]": { flexGrow: 1 }, "& ~ [role=tab-panel] > .MuiBox-root": { py: 0 } }}
      />
    );
  }
}

ScoringClassificationComponent.propTypes = {
  documentScoringGridId: PropTypes.number,
  scoringClassification: PropTypes.object.isRequired,
  indicatorPeriodList: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
  dimensionPeriods: PropTypes.array
};

export default withTranslation()(ScoringClassificationComponent);
